/* eslint-disable react/prop-types */
import React from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from '@nike/eds';
import { InfoCircle } from '@nike/nike-design-system-icons';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { getIsMANASalesOrg } from '../../gamedayAccount/selectors';

import { RETURN_STATUS_OPTIONS, MANA_RETURN_STATUS_OPTIONS, STATUS_COMPLETE } from '../orderReturns/constants';

const StatusToolTip = () => {
  const isMANASalesOrg = useSelector(getIsMANASalesOrg);
  const returnStatuses = isMANASalesOrg ? MANA_RETURN_STATUS_OPTIONS : RETURN_STATUS_OPTIONS;
  return (
    <Tooltip
      id='returnStatusTooltip'
      bodySlot={
        <ul style={{ width: '300px', lineHeight: 'initial' }}>
          {returnStatuses.map(status => {
            const statusString = `returnStatus.returnStatus.${
              isMANASalesOrg && status !== STATUS_COMPLETE ? 'mana.' : ''
            }${status.toLowerCase().replace('in process', 'inprogress')}`;
            return (
              <li style={{ paddingBottom: '5px' }}>
                <span style={{ fontWeight: '500' }}>
                  <TranslatedCopy id={statusString} />
                </span>
                {' - '}
                <TranslatedCopy id={`${statusString}.desc`} />
              </li>
            );
          })}
        </ul>
      }
      isDark
      enableFocus
    >
      <InfoCircle />
    </Tooltip>
  );
};

export default StatusToolTip;
